import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { iRootState } from '../redux/store';

const PaymentScheduleBadge = function PaymentScheduleBadge(): React.ReactElement {
  const { push } = useHistory();

  const quoteId = useSelector((state: iRootState) => state.quote.id);

  const openPaymentSchedule = function openPaymentSchedule(): void {
    push(`/quote/${quoteId}/payment`);
  };
  const onClick = function handleOnClick(): void {
    openPaymentSchedule();
  };

  return (
    <Grid container alignItems='center'>
      <Grid item>
        <Button variant='contained' onClick={onClick}>
          <FormattedMessage
            id='paymentSchedule'
            defaultMessage='View Payment Schedule'
          />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PaymentScheduleBadge;
